'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _SpruceClassName = require('../util/SpruceClassName');

var _SpruceClassName2 = _interopRequireDefault(_SpruceClassName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @module Components
 */

/**
 * @component
 *
 * `Button` is a simple component that displays a button.
 * It does not keep state.
 *
 * @example
 * return <Button>Button text</Button>
 */

var Button = function (_React$Component) {
    (0, _inherits3.default)(Button, _React$Component);

    function Button() {
        (0, _classCallCheck3.default)(this, Button);
        return (0, _possibleConstructorReturn3.default)(this, (Button.__proto__ || (0, _getPrototypeOf2.default)(Button)).apply(this, arguments));
    }

    (0, _createClass3.default)(Button, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                buttonProps = _props.buttonProps,
                children = _props.children,
                className = _props.className,
                disabled = _props.disabled,
                modifier = _props.modifier,
                onClick = _props.onClick,
                peer = _props.peer,
                spruceName = _props.spruceName,
                style = _props.style,
                type = _props.type;


            var additionalClassNames = (0, _defineProperty3.default)({}, spruceName + '-disabled', disabled);

            return _react2.default.createElement('button', (0, _extends3.default)({}, buttonProps, {
                children: children,
                className: (0, _SpruceClassName2.default)({ name: spruceName, modifier: modifier, className: className, peer: peer }, additionalClassNames),
                disabled: disabled,
                onClick: !disabled && onClick,
                type: type,
                style: style
            }));
        }
    }]);
    return Button;
}(_react2.default.Component);

Button.defaultProps = {
    buttonProps: {},
    className: '',
    disabled: false,
    modifier: '',
    peer: '',
    spruceName: 'Button',
    style: {},
    type: 'button'
};
exports.default = Button;


//////////////////
// WEBPACK FOOTER
// ./~/stampy/lib/component/Button.js
// module id = 150
// module chunks = 35783957827783 114276838955818 162898551421021